/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCurrentLocation56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M28.222 13.456a5.794 5.794 0 100 11.588 5.794 5.794 0 000-11.588zm-4.295 5.794a4.294 4.294 0 118.589 0 4.294 4.294 0 01-8.588 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27.503 39.268l.497-.562-.497.562c.284.25.71.25.993 0L28 38.706l.496.562h.001l.01-.01.028-.024.106-.096.397-.364a62.973 62.973 0 005.668-6.045C36.256 30.83 37.82 28.652 39 26.4c1.176-2.243 2-4.614 2-6.88 0-7.572-5.815-13.27-13-13.27s-13 5.698-13 13.27c0 2.266.824 4.637 2 6.88 1.18 2.252 2.744 4.431 4.294 6.329a62.973 62.973 0 006.065 6.41l.106.095.028.025.008.007.002.002zM16.5 19.52c0-6.755 5.154-11.77 11.5-11.77s11.5 5.015 11.5 11.77c0 1.923-.707 4.044-1.828 6.184-1.117 2.13-2.615 4.224-4.128 6.076a61.474 61.474 0 01-5.529 5.896L28 37.69l-.015-.014a61.474 61.474 0 01-5.529-5.896c-1.513-1.852-3.01-3.945-4.128-6.076-1.121-2.14-1.828-4.261-1.828-6.184z'
      />
      <path
        fill='currentColor'
        d='M8.75 32.5a.75.75 0 00-.75.75V49c0 .414.336.75.75.75h38.5A.75.75 0 0048 49V33.25a.75.75 0 00-.75-.75h-7V34h6.25v14.25h-37V34h6.25v-1.5h-7z'
      />
    </svg>
  );
}

export default SvgCurrentLocation56;
